// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","md":"Button_md__-FCch","sm":"Button_sm__QqJTW","primary":"Button_primary__XYgy-","secondary":"Button_secondary__QwN49","ghost":"Button_ghost__PwUIw"};